module.exports = __webpack_public_path__ + "static/img/bambus.dbd6302.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bambus.gif
// module id = 290
// module chunks = 0